
export default {
  name: 'empty'
}
